require('./bootstrap');

window.Vue = require('vue');

/*
 + ElementUI - biblioteca para interfaz de usuario
 */
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es'
window.Vue.use(ElementUI, { locale });

/*
 + Vuesax - biblioteca para interfaz de usuario
 */
 import Vuesax from 'vuesax'
 import 'vuesax/dist/vuesax.css' // Vuesax styles
 // import 'boxicons/css/boxicons.min.css' // Boxicos styles
 window.Vue.use(Vuesax, { locale })

/*
 + Swal - biblioteca para ventanas emergentes
 */
import Swal from 'sweetalert2'
window.Swal = Swal;

/*
 + moment - biblioteca para hora global
 */
import moment from 'moment-timezone'
moment.tz.setDefault('America/Bogota')

/*
 + EventBus - biblioteca para comunicación entre componentes
 */
export const EventBus = new Vue();
window.EventBus = EventBus;

/*
 + VueGoogleMaps - biblioteca para carga de mapas con google maps
 */
// import * as VueGoogleMaps from 'vue2-google-maps'
// window.Vue.use(VueGoogleMaps, {
// 	load: {
// 		key: process.env.MIX_GOOGLE_MAPS_GEOCODING_API_KEY,
// 		libraries: 'places',
// 		region: 'CO',
//     	language: 'es',
// 	}
// });

/** Componente principal para agendamiento de servicio **/
Vue.component('App', require('./components/App.vue').default);

/** Componentes internos **/

const app = new Vue({
    el: '#app'
});
